import React from 'react';
import { get, find, cloneDeep, forEach } from 'lodash';

// React view component to render
import { memberCheckoutShippingOptions as MemberCheckoutShippingOptionsView } from 'ui/views/widgets/memberCheckoutShippingOptions';
import { MemberCheckoutShippingOptionsService } from 'services/memberCheckoutShippingOptions';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/**
 * @type {class}
 * @desc A React container/smart component to render a React presentational/dumb component (view).
 * @example
 * import { MemberCheckoutShippingOptions } from 'ui/containers/MemberCheckoutShippingOptions';
 *
 * // render
 * <MemberCheckoutShippingOptions propName='propValue'/>
 */
export class MemberCheckoutShippingOptions extends React.Component {
	/**
	 * @param {object} props - props
	 */
	constructor(props) {
		super(props);

		// bind
		this.handleShippingOptionSelection =
			this.handleShippingOptionSelection.bind(this);

		// component state
		this.state = {
			isFetching: true,
			networkStatus: undefined,
			componentData: undefined,
		};

		// Member Detail instance
		this.memberCheckoutShippingOptionsService =
			new MemberCheckoutShippingOptionsService();

		// start member detail data fetch
		//   this.fetchComponentData();
	}

	/**
	 * @desc Fetch component response.
	 */
	async fetchComponentData() {
		log.debug('MemberCheckoutShippingOptions.fetchComponentData()');

		// cancel ongoing request
		this.memberCheckoutShippingOptionsService.cancel();
		const requestData = {
			zipCode: this.props.zipCode,
			...this.props.requestPayload,
		};
		// fetch component data
		const { status, data } =
			await this.memberCheckoutShippingOptionsService.fetchComponentData({
				url: this.props.widget.url,
				data: {
					...requestData,
				},
			});

		// check if response status was success
		if (SERVICE_RESPONSE_STATUS.SUCCESS !== status) {
			this.setState({
				isFetching: false,
				networkStatus: SERVICE_RESPONSE_STATUS.FAILURE,
			});
		} else {
			// get the address list
			const shippingOptions = get(data, 'shippingOptions', []);

			// get selected address
			const shippingOption = find(shippingOptions, { selected: true });

			this.setState(
				{
					isFetching: false,
					networkStatus: SERVICE_RESPONSE_STATUS.SUCCESS,
					componentData: data,
				},
				() => {
					// call update function to inform parent container
					this.props.updateCheckoutSelection({
						type: 'shippingOption',
						item: shippingOption,
					});
				}
			);
		}
	}

	componentDidUpdate(preProps, preState) {
		if (this.props.zipCode != preProps.zipCode) {
			this.fetchComponentData();
		}
	}
	

	/**
	 * action executed when user updates a selection
	 */
	handleShippingOptionSelection(item) {
		log.debug('MemberCheckoutShippingOptions.handleShippingOptionSelection()');
		// get the address list
		const componentData = cloneDeep(this.state.componentData);

		forEach(componentData.shippingOptions, (option) => {
			option.selected = option.id === item.id;
		});

		this.setState({ componentData }, () => {
			// get selected address
			const shippingOption = find(
				get(this.state.componentData, 'shippingOptions'),
				{ selected: true }
			);

			// call update function to inform parent container
			this.props.updateCheckoutSelection({
				type: 'shippingOption',
				item: shippingOption,
			});
		});
	}

	/*********************************************/

	/**
	 * @desc When component unmounts, cleanup resouces.
	 */
	componentWillUnmount() {
		this.memberCheckoutShippingOptionsService.cancel(); // cancel ongoing requests
	}

	/**
	 * @desc Render a React view component
	 */
	render() {
		return (
			<div style={{ display: 'none'}}><MemberCheckoutShippingOptionsView
				isFetching={this.state.isFetching}
				networkStatus={this.state.networkStatus}
				{...get(this.state, 'componentData', {})}
				requestPayload={this.props.requestPayload}
				onShippingOptionSelection={this.handleShippingOptionSelection} /></div>
		);
	}
}

// set display name
MemberCheckoutShippingOptions.displayName = 'MemberCheckoutShippingOptions';

// set default props
MemberCheckoutShippingOptions.defaultProps = {};

// prop types
MemberCheckoutShippingOptions.propTypes = {};
